import React from 'react';
import { CTAButton } from './CTAButton';
export function ProblemSection() {
  const problems = ['Llegas a cada semana sin una estructura clara… armando todo sobre la marcha', 'Pierdes horas haciendo planificaciones, sesiones o registros desde cero', 'Sientes que siempre te falta algo: formatos, evaluaciones, documentos o actividades', 'Aunque trabajas mucho, igual terminas con estrés y desorden'];
  return <section className="bg-brand-dark text-white py-5 px-5" data-id="element-240">
      <div className="max-w-xl mx-auto" data-id="element-241">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-3 leading-tight" data-id="element-242">
          😩 ¿Estás viviendo esto...?
        </h2>
        <p className="text-center text-brand-yellow font-bold text-lg mb-8" data-id="element-243">
          Te va a sonar familiar:
        </p>

        <div className="space-y-3 mb-10" data-id="element-244">
          {problems.map((problem, idx) => <div key={idx} className="bg-gray-900 border border-gray-800 p-4 rounded-xl flex items-start gap-3" data-id="element-245">
              <span className="text-red-500 text-lg flex-shrink-0" data-id="element-246">❌</span>
              <p className="text-sm text-gray-300 font-medium leading-relaxed" data-id="element-247">
                {problem}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-248">
          <h3 className="text-xl md:text-2xl font-bold text-brand-yellow mb-6" data-id="element-249">
            ¿Cuánto tiempo más vas a seguir trabajando así?
          </h3>
        </div>
      </div>
    </section>;
}